/**
 * 配車計画 ドライバー配車 運搬統合
 */
import Vue from 'vue'
import * as httpConst from '../../../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/allocations/drivers`

const allocation_switch_driver = {
  namespaced: true,
  actions: {
    update({ commit }, { base_driver_id, params }) {
      const api_path = `${API_PATH}/${base_driver_id}/switching`
      return new Promise( ( resolve ) => {
        Vue.$http.put(api_path, params).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '変更しました' }, { root: true })
          resolve(content)
        } )
      })
    },
  },
}
export default allocation_switch_driver
